var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.439,
    height: 61.445,
    viewBox: "0 0 61.439 61.445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Home",
    d: "M60.289,26.725l0,0L35.22,1.657a5.656,5.656,0,0,0-8,0L2.168,26.708l-.025.026a5.654,5.654,0,0,0,3.764,9.637c.058.006.116.008.175.008h1V54.824a6.628,6.628,0,0,0,6.621,6.62h9.806a1.8,1.8,0,0,0,1.8-1.8V45.183a3.024,3.024,0,0,1,3.021-3.02h5.784a3.024,3.024,0,0,1,3.02,3.02V59.645a1.8,1.8,0,0,0,1.8,1.8h9.806a6.628,6.628,0,0,0,6.621-6.62V36.379h.926a5.658,5.658,0,0,0,4-9.654ZM57.74,32.176a2.044,2.044,0,0,1-1.454.6H53.559a1.8,1.8,0,0,0-1.8,1.8V54.825a3.024,3.024,0,0,1-3.02,3.02H40.732V45.183a6.628,6.628,0,0,0-6.621-6.621H28.328a6.629,6.629,0,0,0-6.621,6.621V57.844H13.7a3.024,3.024,0,0,1-3.02-3.02V34.579a1.8,1.8,0,0,0-1.8-1.8H6.2l-.084,0A2.054,2.054,0,0,1,4.7,29.267h0L29.766,4.2a2.055,2.055,0,0,1,2.907,0L57.732,29.26l.012.011a2.061,2.061,0,0,1,0,2.905Zm0,0",
    transform: "translate(-0.5 0.001)",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.6a9b26c9087d3391a967b59bd4d2412c.svg";
export { ForwardRef as ReactComponent };